"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconSSCancellationSuccessWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../commonFunctions");
var FalconSSCancellationSuccessWidget = /** @class */ (function (_super) {
    __extends(FalconSSCancellationSuccessWidget, _super);
    function FalconSSCancellationSuccessWidget(props) {
        return _super.call(this, props) || this;
    }
    FalconSSCancellationSuccessWidget.prototype.render = function () {
        var amount = this.props.interaction.factors.returnPremium;
        return ((0, jsx_runtime_1.jsx)("div", { className: "widget premium-widget", children: (0, jsx_runtime_1.jsx)("div", { className: "inner-panel bg-white-blue p-0", children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: "content", children: [(0, jsx_runtime_1.jsx)("div", { className: "price-text text-blue-2", children: amount !== 0 ? "Your refund" : "There is no refund due" }), amount !== 0 && (0, jsx_runtime_1.jsx)("div", { id: "price", className: "price text-center font-weight-bold font-family-display", children: (0, commonFunctions_1.getAmountToDisplay)(amount) })] }) }) }) }));
    };
    return FalconSSCancellationSuccessWidget;
}(plugin_journey_1.WidgetBase));
exports.FalconSSCancellationSuccessWidget = FalconSSCancellationSuccessWidget;
//# sourceMappingURL=FalconSSCancellationSuccessWidget.js.map